import { fromJS } from "immutable"
import { GET_SYNCHRONIZATION_ERRORS_FAILED, GET_SYNCHRONIZATION_ERRORS_SUCCESS, GET_SYNCHRONIZATION_ERRORS_WATCHER } from "./contants"


export const initialState = fromJS({
    isLoadingSynchronizationErrors: false,
    synchronizationErrors: []
})

function synchronizationErrorsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SYNCHRONIZATION_ERRORS_WATCHER:
            return state.set("isLoadingSynchronizationErrors", true)
        case GET_SYNCHRONIZATION_ERRORS_SUCCESS:
            return state.set("synchronizationErrors", action.payload).set("isLoadingSynchronizationErrors", false)
        case GET_SYNCHRONIZATION_ERRORS_FAILED:
            return state.set("synchronizationErrors", []).set("isLoadingSynchronizationErrors", false)
        default:
            return state
    }
}

export default synchronizationErrorsReducer
